export class User {
  constructor([firstName = 'Guest', lastName = 'Guest', age = null]) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.age = age;
  }
}
